/* unplugin-vue-components disabled */import script from "./InterviewQuestionList.vue?vue&type=script&setup=true&lang=js"
export * from "./InterviewQuestionList.vue?vue&type=script&setup=true&lang=js"

import "./InterviewQuestionList.vue?vue&type=style&index=0&id=39d12b3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39d12b3a"]])

export default __exports__